import { useEffect, useMemo, useState } from 'react';
import { loadEnglishWords, mightBeEnglish, readsAsEnglish, type WordList } from './word-completion';

/**
 * The list of English words while the text reads as English, whatever language its rewrites are
 * to be in: until there's a whole word to tell by, if `assumeEnglish`. Null otherwise, and until
 * the list has downloaded, which it only does once the text could be English.
 */
export function useEnglishWords(text: string, assumeEnglish: boolean): WordList | null {
  const [words, setWords] = useState<WordList | null>(null);
  const wanted = mightBeEnglish(text);

  useEffect(() => {
    if (!wanted || words) return;
    let current = true;
    loadEnglishWords().then(
      (list) => {
        if (current) setWords(list);
      },
      () => {
        // Completion is an extra: typing works just the same without it.
      },
    );
    return () => {
      current = false;
    };
  }, [wanted, words]);

  return useMemo(
    () => (words && (readsAsEnglish(words, text) ?? assumeEnglish) ? words : null),
    [assumeEnglish, text, words],
  );
}
